/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-favorite-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.031 2.5a4.669 4.669 0 00-3.337 1.4L10 4.6l-.694-.7a4.681 4.681 0 00-6.675 0 4.825 4.825 0 000 6.762L10 18.125l7.369-7.463a4.825 4.825 0 000-6.762 4.681 4.681 0 00-3.338-1.4z"/>'
  }
})
